module.exports = __webpack_public_path__ + "static/media/Image_21.db14bd29.png";